import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createGADrawing, updateGADrawing , removeGADrawing , getGADrawing} from '../api/util';
import { RootState } from '../store';


export interface ProjectState {
    gaDrawingList?: any[],
    newProjectResponse?:any,
    fetching: boolean,
}

const initialState: ProjectState = {
    gaDrawingList: undefined,
    fetching:false

}


export const createGADrawingModel = createAsyncThunk(
    'bladeModal/createHubBand',
    async (data: any, thunkAPI) => {
        try {
            const response = await createGADrawing(data);
            return response.response;
        } catch (error) {
            console.log("createNewModel", error);
            return error;
        }
    }
);
export const updateGADrawingModel = createAsyncThunk(
    'bladeModal/updateHubBand',
    async (data: any) => {
        const response = await updateGADrawing(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);


export const removeGADrawingModel = createAsyncThunk(
    'bladeModal/removeHubBand',
    async (data: any) => {
        const response = await removeGADrawing(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);

export const getGADrawingModel = createAsyncThunk(
    'bladeModal/getHubBandAPI',
    async () => {
        const response = await getGADrawing();
        console.log("getBladeModels",response.response)
        return response.response;
    }
);


export const GADrawingSlice = createSlice({
    name: 'gaDrawingModel',
    initialState,
    reducers: {
        resetBladeModelStore: (state) => {
            state = initialState;
        }
    }, extraReducers: (builder) => {
        builder
            .addCase(getGADrawingModel.pending, (state) => {
                state.fetching = true;
                state.gaDrawingList = undefined
            })
            .addCase(getGADrawingModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.gaDrawingList = action.payload.data;
            })
            .addCase(getGADrawingModel.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(updateGADrawingModel.pending, (state) => {
                state.fetching = true;
                state.gaDrawingList = undefined
            })
            .addCase(updateGADrawingModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.gaDrawingList = action.payload.data;
            })
            .addCase(updateGADrawingModel.rejected, (state) => {
                state.fetching = false;
            })


            .addCase(removeGADrawingModel.pending, (state) => {
                state.fetching = true;
                state.gaDrawingList = undefined
            })
            .addCase(removeGADrawingModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.gaDrawingList = action.payload.data;
            })
            .addCase(removeGADrawingModel.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(createGADrawingModel.pending, (state,action) => {
                state.fetching = true;
                state.newProjectResponse = undefined
            })
            .addCase(createGADrawingModel.fulfilled, (state, action) => {
              
                state.fetching = false;
                state.newProjectResponse = action.payload
            })
            .addCase(createGADrawingModel.rejected, (state,action) => {
                state.fetching = false;
                state.newProjectResponse = action.error.message ;
            })
    }
})


export const { resetBladeModelStore } = GADrawingSlice.actions;

export const getGADrawingModelList = (state: RootState) => state.gaDrawingModel.gaDrawingList;
export const newProjectResponse = (state: RootState) => state.gaDrawingModel.newProjectResponse;


export default GADrawingSlice.reducer;